import { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import InterestsRoundedIcon from '@mui/icons-material/InterestsRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import TopicRoundedIcon from '@mui/icons-material/TopicRounded';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';

import { SectionCard, ChartTile, EmptyState, ui, fmtCount } from '../shared/insightUi';

import ActorIcon from 'assets/planner/Actor.png';
import AgricultureIcon from 'assets/planner/Agriculture.png';
import ArtCraftIcon from 'assets/planner/Art-Craft.png';
import AutomobileIcon from 'assets/planner/Automobile.png';
import BeautyIcon from 'assets/planner/beauty.png';
import BusinessCareerIcon from 'assets/planner/Business-Careers.png';
import CareerCoachIcon from 'assets/planner/Career-Coach.png';
import ComedyIcon from 'assets/planner/Comedy.png';
import CryptoIcon from 'assets/planner/Crypto.png';
import DanceIcon from 'assets/planner/Dance.png';
import DecorIcon from 'assets/planner/Decor.png';
import DigitalMarketingIcon from 'assets/planner/Digital-Marketing.png';
import EducationIcon from 'assets/planner/Education.png';
import EntertainmentPageIcon from 'assets/planner/Entertainment-Page.png';
import EntertainmentIcon from 'assets/planner/Entertainment.png';
import FanPageIcon from 'assets/planner/Fan-Page.png';
import FashionIcon from 'assets/planner/Fashion.png';
import FinanceIcon from 'assets/planner/Finance.png';
import FoodIcon from 'assets/planner/Food.png';
import GadgetReviewIcon from 'assets/planner/Gadget-Review.png';
import GamingIcon from 'assets/planner/Gaming.png';
import GraphicDesignerIcon from 'assets/planner/Graphic-Designer.png';
import HaircareIcon from 'assets/planner/Haircare.png';
import HealthIcon from 'assets/planner/Health.png';
import InfortainmentIcon from 'assets/planner/Infotainment.png';
import InvestmentIcon from 'assets/planner/Investment.png';
import LegalIcon from 'assets/planner/Legal.png';
import LifestyleIcon from 'assets/planner/Lifestyle.png';
import LiteratureIcon from 'assets/planner/Literature.png';
import MemePageIcon from 'assets/planner/Meme-Page.png';
import MensGroomingIcon from 'assets/planner/Mens-Grooming.png';
import ModelIcon from 'assets/planner/Model.png';
import MusicIcon from 'assets/planner/Music.png';
import NewsMediaIcon from 'assets/planner/News-Media.png';
import NutritionIcon from 'assets/planner/Nutrition.png';
import ParentingIcon from 'assets/planner/Parenting.png';
import PetsIcon from 'assets/planner/Pets.png';
import PhotographyIcon from 'assets/planner/Photography.png';
import ProductReviewIcon from 'assets/planner/Product-Review.png';
import SelfMotivationIcon from 'assets/planner/Self-Help-Motivation.png';
import SkincareIcon from 'assets/planner/Skincare.png';
import SpiritualityIcon from 'assets/planner/Spirituality.png';
import SportsIcon from 'assets/planner/Sports.png';
import StockMarketIcon from 'assets/planner/Stock-Market.png';
import Sustainability from 'assets/planner/Sustainability.png';
import TechnologyIcon from 'assets/planner/Technology.png';
import TheatreIcon from 'assets/planner/Theatre.png';
import TravelIcon from 'assets/planner/Travel.png';
import TvReviewIcon from 'assets/planner/TV-Review.png';
import WebsiteToolsIcon from 'assets/planner/Website-Tools.png';

import ActivewearIcon from 'assets/planner/Activewear.png';
import ArtDesignIcon from 'assets/planner/Art-and-Design.png';
import BeautyCosmeticIcon from 'assets/planner/Beauty-and-Cosmetics.png';
import BeerWineIcon from 'assets/planner/Beer-Wine-&-Spirits.png';
import CameraPhotographyIcon from 'assets/planner/Camera-&-Photography.png';
import CarMotorbikeIcon from 'assets/planner/Cars-&-Motorbikes.png';
import ClothesShoesIcon from 'assets/planner/Clothes-Shoes.png';
import CoffeeTeaIcon from 'assets/planner/Coffee-Tea-&-Beverages.png';
import ElectronicsComputerIcon from 'assets/planner/Electronics-and-Computers.png';
import FitnessYogaIcon from 'assets/planner/Yoga.png';
import FriendsFamilyIcon from 'assets/planner/Friends-Family-&-Relationships.png';
import HealthcareMedicineIcon from 'assets/planner/Healthcare-and-Medicine.png';
import HealthyLifestyleIcon from 'assets/planner/Healthy-Lifestyle.png';
import HomeDecorIcon from 'assets/planner/Home-Decor-Furniture-&-Garden.png';
import JewlleryWatchesIcon from 'assets/planner/Jewellery-&-Watches.png';
import LuxaryGoodsIcon from 'assets/planner/Luxury-Goods.png';
import RestaurantFoodIcon from 'assets/planner/Restaurants-Food-&-Grocery.png';
import ShoppingRetail from 'assets/planner/Shopping-&-Retail.png';
import TelevisionFilmsIcon from 'assets/planner/Television-and-Film.png';
import TobaccoSmokingIcon from 'assets/planner/Tobacco-&-Smoking.png';
import ToysIcon from 'assets/planner/Toys-Children-&-Baby.png';
import TravelTourismIcon from 'assets/planner/Travel-Tourism-and-Aviation.png';
import WeddingIcon from 'assets/planner/Wedding.png';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
);

const interestsIcon = {
  Actor: ActorIcon,
  Agriculture: AgricultureIcon,
  'Art and craft': ArtCraftIcon,
  Automobile: AutomobileIcon,
  Beauty: BeautyIcon,
  'Career Coach': CareerCoachIcon,
  Comedy: ComedyIcon,
  Crypto: CryptoIcon,
  Dance: DanceIcon,
  Decor: DecorIcon,
  'Digtal Marketing': DigitalMarketingIcon,
  Education: EducationIcon,
  'Entertainment Page': EntertainmentPageIcon,
  Entertainment: EntertainmentIcon,
  'Fan Page': FanPageIcon,
  Fashion: FashionIcon,
  'Fashion	Male': MensGroomingIcon,
  Finance: FinanceIcon,
  Fitness: HealthIcon,
  Food: FoodIcon,
  'Gadget Review': GadgetReviewIcon,
  'Gaming / E-sports': GamingIcon,
  'Graphic Designer': GraphicDesignerIcon,
  Haircare: HaircareIcon,
  Health: HealthIcon,
  'home decor ': DecorIcon,
  Infotainment: InfortainmentIcon,
  Investment: InvestmentIcon,
  Kids: InvestmentIcon,
  Legal: LegalIcon,
  Lifestyle: LifestyleIcon,
  'Meme Page': MemePageIcon,
  "Men's Grooming": MensGroomingIcon,
  Model: ModelIcon,
  'News Media': NewsMediaIcon,
  Nutrition: NutritionIcon,
  Motivation: SelfMotivationIcon,
  'Self Motivation': SelfMotivationIcon,
  Parenting: ParentingIcon,
  Photography: PhotographyIcon,
  'Product Review': ProductReviewIcon,
  Skincare: SkincareIcon,
  Spirituality: SpiritualityIcon,
  'Stock Market': StockMarketIcon,
  Sustainability: Sustainability,
  Theatre: TheatreIcon,
  'Self Help': SelfMotivationIcon,
  Tech: TechnologyIcon,
  Technology: TechnologyIcon,
  Literature: LiteratureIcon,
  Travel: TravelIcon,
  'Tv Review': TvReviewIcon,
  'Website Tools': WebsiteToolsIcon,
  'Travel / Content Creator': TravelIcon,
  'Travel/ Food': TravelIcon,
  'Travel/ lifestyle': TravelIcon,
  'Television & Film': TelevisionFilmsIcon,
  Music: MusicIcon,
  'Shopping & Retail': ShoppingRetail,
  'Coffee, Tea & Beverages': CoffeeTeaIcon,
  'Camera & Photography': CameraPhotographyIcon,
  'Clothes, Shoes, Handbags & Accessories': ClothesShoesIcon,
  'Beer, Wine & Spirits': BeerWineIcon,
  Sports: SportsIcon,
  'Electronics & Computers': ElectronicsComputerIcon,
  Gaming: GamingIcon,
  Activewear: ActivewearIcon,
  'Art & Design': ArtDesignIcon,
  'Travel, Tourism & Aviation': TravelTourismIcon,
  'Business & Careers': BusinessCareerIcon,
  'Beauty & Cosmetics': BeautyCosmeticIcon,
  'Healthcare & Medicine': HealthcareMedicineIcon,
  'Jewellery & Watches': JewlleryWatchesIcon,
  'Restaurants, Food & Grocery': RestaurantFoodIcon,
  'Toys, Children & Baby': ToysIcon,
  'Fitness & Yoga': FitnessYogaIcon,
  Wedding: WeddingIcon,
  'Tobacco & Smoking': TobaccoSmokingIcon,
  Pets: PetsIcon,
  'Healthy Lifestyle': HealthyLifestyleIcon,
  'Luxury Goods': LuxaryGoodsIcon,
  'Home Decor, Furniture & Garden': HomeDecorIcon,
  'Friends, Family & Relationships': FriendsFamilyIcon,
  'Cars & Motorbikes': CarMotorbikeIcon,
};

const MONTH = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

const trendOptions = {
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    y: {
      grid: { color: 'rgba(16, 24, 40, 0.05)', drawBorder: false },
      ticks: { font: { size: 10 }, color: '#98A2B3' },
    },
    x: {
      grid: { display: false, drawBorder: false },
      ticks: { font: { size: 10 }, color: '#98A2B3' },
    },
  },
  elements: {
    line: { tension: 0.35 },
    point: { radius: 3, hoverRadius: 5 },
  },
};

function TrendLine({ labels, data, label }) {
  return (
    <Line
      data={{
        labels,
        datasets: [
          {
            label,
            data,
            borderColor: '#4F46E5',
            backgroundColor: 'rgba(79, 70, 229, 0.10)',
            fill: true,
            borderWidth: 2,
            pointBackgroundColor: '#4F46E5',
          },
        ],
      }}
      options={trendOptions}
    />
  );
}

const thStyle = {
  textAlign: 'left',
  fontSize: 11,
  fontWeight: 700,
  color: ui.inkFaint,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  padding: '8px 12px',
  borderBottom: `1px solid ${ui.borderSoft}`,
  position: 'sticky',
  top: 0,
  background: ui.card,
  fontFamily: ui.font,
};

/**
 * Row avatar with a fallback: similar-profile `picture` URLs come from
 * platform CDNs and routinely expire or 403, which used to leave the
 * browser's broken-image icon in the table. On error (or no URL) render an
 * initial-letter disc instead.
 */
function RowAvatar({ src, name }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: '50%',
          flex: '0 0 auto',
          background: ui.primarySoft,
          color: ui.primary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 14,
          fontWeight: 800,
          fontFamily: ui.font,
          textTransform: 'uppercase',
        }}
      >
        {(name || '?').trim().charAt(0) || '?'}
      </div>
    );
  }
  return (
    <img
      alt=""
      src={src}
      onError={() => setFailed(true)}
      style={{ width: 34, height: 34, borderRadius: '50%', objectFit: 'cover', flex: '0 0 auto', background: '#EEF0F6' }}
    />
  );
}

function SimilarTable({ rows }) {
  if (!rows || rows.length === 0) {
    return <EmptyState>No data available</EmptyState>;
  }
  return (
    <div style={{ overflowY: 'auto', height: '100%' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: ui.font }}>
        <thead>
          <tr>
            <th style={{ ...thStyle, width: '55%' }}>Influencer</th>
            <th style={{ ...thStyle, textAlign: 'right' }}>Engagements</th>
            <th style={{ ...thStyle, textAlign: 'right' }}>Followers</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((data, i) => (
            <tr key={i}>
              <td style={{ padding: '10px 12px', borderBottom: `1px solid ${ui.borderSoft}` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                  <RowAvatar src={data.picture} name={data.username || data.fullname} />
                  <div style={{ minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: ui.primary,
                          cursor: 'pointer',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                        onClick={() => {
                          window.open(data.url, '_blank');
                        }}
                      >
                        {data.username.length > 0 ? data.username : data.fullname}
                      </span>
                      {data.is_verified ? (
                        <VerifiedRoundedIcon style={{ fontSize: 14, color: '#2563EB', flex: '0 0 auto' }} />
                      ) : null}
                    </div>
                    {data.location ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 2 }}>
                        <LocationOnIcon style={{ fontSize: 12, color: ui.inkFaint }} />
                        <span style={{ fontSize: 11.5, color: ui.inkFaint, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {data.location.length < 24 ? data.location : `${data.location.slice(0, 24)}...`}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </td>
              <td style={{ padding: '10px 12px', borderBottom: `1px solid ${ui.borderSoft}`, textAlign: 'right', fontSize: 13, fontWeight: 700, color: ui.ink }}>
                {fmtCount(data.engagements)}
              </td>
              <td style={{ padding: '10px 12px', borderBottom: `1px solid ${ui.borderSoft}`, textAlign: 'right', fontSize: 13, fontWeight: 700, color: ui.ink }}>
                {fmtCount(data.followers)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function InfluencerDetails({
  interests = [],
  fair_price,
  brand_affinity = [],
  avg_comments,
  avg_likes,
  stat_history,
  interest_categories = [],
  similar_audience,
  similar_users,
  list,
  bc_public_data,
  is_brandconnect,
}) {
  const dataSharingEnabled =
    String(bc_public_data?.dataSharingState || '')
      .toUpperCase()
      .includes('ENABLED') ||
    String(bc_public_data?.dataSharingState || '')
      .toUpperCase()
      .includes('GIVEN');
  const isBC = is_brandconnect === 'yes' && dataSharingEnabled;

  // Every block below is estimate-based and hidden for connected (BC)
  // profiles, so there is nothing to render inside the section shell.
  if (isBC) return null;

  const trendLabels = stat_history?.map((x) => MONTH[x['month'].split('-')[1]]);

  return (
    <SectionCard
      icon={<QueryStatsRoundedIcon fontSize="small" />}
      title="Influencer details"
      subtitle="Growth trends, interests and similar creators"
    >
      {/* Trend + interests row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
        <ChartTile
          icon={<GroupsRoundedIcon style={{ fontSize: 17 }} />}
          title="Followers trend"
          height={280}
        >
          <TrendLine labels={trendLabels} data={stat_history?.map((x) => x['followers'])} label="Followers" />
        </ChartTile>
        <ChartTile
          icon={<FavoriteRoundedIcon style={{ fontSize: 16 }} />}
          title="Avg likes trend"
          height={280}
        >
          <TrendLine labels={trendLabels} data={stat_history?.map((x) => x['avg_likes'])} label="Likes" />
        </ChartTile>
        <ChartTile
          icon={<InterestsRoundedIcon style={{ fontSize: 16 }} />}
          title="Interests"
          height={280}
        >
          {interest_categories && interest_categories.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, overflowY: 'auto', height: '100%' }}>
              {interest_categories.slice(0, 6).map((interest, i) => (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    background: ui.tileBg,
                    border: `1px solid ${ui.borderSoft}`,
                    borderRadius: 10,
                    padding: '8px 12px',
                  }}
                >
                  <img
                    alt=""
                    src={interestsIcon[Object.keys(interest).length > 0 ? interest : '']}
                    style={{ width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: 13, fontWeight: 700, color: ui.inkSoft, fontFamily: ui.font }}>
                    {Object.keys(interest).length > 0 ? interest : ''}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <EmptyState>No data available</EmptyState>
          )}
        </ChartTile>
      </div>

      {/* Lookalike tables */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 16, marginTop: 16 }}>
        <ChartTile
          icon={<PeopleAltRoundedIcon style={{ fontSize: 16 }} />}
          title="Similar audience"
          height={420}
        >
          <SimilarTable rows={similar_audience} />
        </ChartTile>
        <ChartTile
          icon={<TopicRoundedIcon style={{ fontSize: 16 }} />}
          title="Similar topics"
          height={420}
        >
          <SimilarTable rows={similar_users} />
        </ChartTile>
      </div>
    </SectionCard>
  );
}

export default InfluencerDetails;
